import _fetch, { type ClientFetchOptions } from '@avalara/bat-apps-shared/lib/client-fetch';
import type { DefaultErrorDetails, Result } from '@avalara/types/index';

import { isOneWebDomainRuntime } from '../helpers';
import { loadingDataFinish, loadingDataStart } from '../store/data';
import { checkIsAuthenticated } from './helpers';

import type { Dispatch } from '@avalara/types/actions';
import type { AdditionalHeaders } from '@avalara/types/index';

type FetchParams = {
  retry?: boolean;
  showLoadingWheel?: boolean;
};

/** Simple fetch helper */
const fetch = (dispatch: Dispatch, fetchParams: FetchParams = {}) =>
  async function f<S, E = DefaultErrorDetails>(
    url: RequestInfo,
    params: RequestInit = {},
    additionalHeaders?: AdditionalHeaders,
  ): Promise<Result<S, E>> {
    const baseHeaders = {
      'cache-control': 'no-cache',
      'Content-Type': 'application/json',
    };

    const headers = {
      ...baseHeaders,
      ...additionalHeaders,
    };

    if (isOneWebDomainRuntime() && checkIsAuthenticated()) {
      const accessTokenRes = await _fetch<{ accessToken: string }>({
        url: `${window.AvaAppConfig?.hostnames.avaApp}/api/token`,
      });
      if (accessTokenRes.ok) {
        const { accessToken } = accessTokenRes.value;
        headers.Authorization = `Bearer ${accessToken}`;
      }
    }

    if (fetchParams.showLoadingWheel !== false) dispatch(loadingDataStart());

    const fetchOptions: ClientFetchOptions = {
      url,
      params: {
        ...params,
        credentials: 'include',
        headers,
      },
      timeout: 120000,
    };

    let result = await _fetch<S, E>(fetchOptions);
    if (fetchParams.retry != null && !result.ok) {
      result = await _fetch<S, E>(fetchOptions);
    }

    if (fetchParams.showLoadingWheel !== false) dispatch(loadingDataFinish());

    return result;
  };

export default fetch;
